export const COMPUTE_TYPE_AMOUNT = 'AMOUNT'
export const COMPUTE_TYPE_RENT = 'RENT'
